// extracted by mini-css-extract-plugin
export default {"menuItem":"h7O4a_1ctgjeMCIl6MHw","code":"ZCo2Q0Y0u1SdkNmJStJd","result-wrapper":"fotaAFvxLLT9ANbStzoR","resultWrapper":"fotaAFvxLLT9ANbStzoR"};